import { render, staticRenderFns } from "./kTojIndex.vue?vue&type=template&id=227ba3dc&scoped=true&"
import script from "./kTojIndex.vue?vue&type=script&lang=js&"
export * from "./kTojIndex.vue?vue&type=script&lang=js&"
import style0 from "./kTojIndex.vue?vue&type=style&index=0&id=227ba3dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ba3dc",
  null
  
)

export default component.exports